import { Form, notification } from 'antd';
import { useIntl } from 'react-intl';
import { PageProps } from '@/types/PageProps';
import { SaveButton, TabContentWrapper } from '@/components/_common';
import NotificationForm from '@/components/Notification/NotificationForm';
import {
  MessageCreateRequest,
  MessageFormValues,
} from '@/core/domain/notification/Message/Message.types';
import { DateTimeFormat } from '@/utils/moment';
import { useMessageCreate } from '@/core/domain/notification/Message/Message.hooks';
import { useHistory } from 'react-router-dom';

const NotificationsCreatePage = ({ route }: PageProps) => {
  const intl = useIntl();
  const history = useHistory();

  const [form] = Form.useForm<MessageFormValues>();

  const createMessageMutation = useMessageCreate();

  const handleSubmit = async () => {
    const values = await form.validateFields();

    if (!values.listUserIds?.length) {
      return notification.error({
        message: 'Atenção!',
        description:
          'Não é possivel cadastrar uma notificação sem ao menos marcar 1 usuário!',
      });
    }

    if (values.listUserIds?.length) {
      const obj: MessageCreateRequest = {
        ...values,
        dateTime: values.dateTime.format(DateTimeFormat),
      };

      await createMessageMutation.mutateAsync(obj);

      history.push('/app/notifications');
    }
  };

  return (
    <TabContentWrapper
      permissions={route.permissions}
      title={route.name}
      extra={
        <SaveButton
          type="primary"
          onClick={handleSubmit}
          loading={createMessageMutation.isLoading}
        >
          {intl.formatMessage({ id: 'commons.form.button.save' })}
        </SaveButton>
      }
    >
      <NotificationForm form={form} />
    </TabContentWrapper>
  );
};

export default NotificationsCreatePage;
